import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".bullet-library--fgPr0 {\n  list-style-position: inside;\n  list-style-type: square;\n}\n\n.numbered-library--3fH8Q {\n  list-style-type: decimal;\n  list-style-position: inside;\n}\n\n.wrap-library--c3XEy {\n  white-space: pre-line;\n}";
var styles = {"bullet":"bullet-library--fgPr0","numbered":"numbered-library--3fH8Q","wrap":"wrap-library--c3XEy"};
styleInject(css_248z);

export { styles as default };
